import React, { Fragment, useEffect, useState } from "react";
import axios from "axios";

function EquipoConsultaExterna(props) {
  const [list, setList] = useState([]);
  useEffect(() => {
    axios({
      method: "get",
      auth: {
        username: "BasicAuth@icontec.org",
        password: "yQLzqmR7eZSuAmQZUqhY",
      },
      url: "https://suadesarrollo.azurewebsites.net/api/ObtenerEquipoConsultaExterna",
    })
      .then((Response) => {
        setList(Response.data);
        console.log(Response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [setList]);
  return (
    <Fragment>
      <div className="container">
        <div className="text-center">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">
                <h6 class="m-0 font-weight-bold text-primary">
                  Equipo Primario de Mejoramiento de Consulta Externa Médica y
                  Paramédica
                </h6>
              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table
                    class="table table-bordered"
                    id="dataTable"
                    width="100%"
                    cellspacing="0"
                  >
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>Nombre</th>
                        <th>Servcio</th>
                        <th>Cargo</th>
                      </tr>
                    </thead>
                    <tbody>
                      {list.map((item) => {
                        return (
                          <tr>
                            <td>{item.id}</td>
                            <td>{item.nombre}</td>
                            <td>{item.servicio}</td>
                            <td>{item.cargo}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}
export default EquipoConsultaExterna;
